class MobileDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.activeTab = 'shop';
    this.panel = this.querySelector('[data-drawer-panel]');
    this.overlay = this.querySelector('[data-drawer-overlay]');
    this.tabs = this.querySelectorAll('[data-drawer-tab]');
    this.contents = this.querySelectorAll('[data-drawer-content]');
    this.toggleButton = document.querySelector('[data-mobile-menu-toggle]');
    this.stickyButton = document.querySelector('sticky-button') || null;
    this.controller = null;
  }

  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;

    if (this.toggleButton) {
      this.toggleButton.addEventListener(
        'click',
        () => {
          this.isOpen ? this.close() : this.open();
        },
        { signal }
      );
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close(), { signal });
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener(
        'click',
        () => {
          this.switchTab(tab.dataset.drawerTab);
        },
        { signal }
      );
    });

    this.panel
      .querySelectorAll('[data-sublevel-trigger]')
      .forEach((trigger) => {
        trigger.addEventListener(
          'click',
          () => {
            this.openSublevel(trigger.dataset.sublevelTrigger);
          },
          { signal }
        );
      });

    this.panel.querySelectorAll('[data-sublevel-back]').forEach((back) => {
      back.addEventListener(
        'click',
        () => {
          this.closeSublevel(back);
        },
        { signal }
      );
    });
  }

  isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  applyScrollLock() {
    if (this.isSafari()) {
      window.cbScrollLock?.lock();
    } else {
      window.cbScrollLock?.lockScroll();
    }
  }

  applyScrollUnlock() {
    if (this.isSafari()) {
      window.cbScrollLock?.unlock();
    } else {
      window.cbScrollLock?.unlockScroll();
    }
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
    if (this.stickyButton) this.stickyButton.classList.remove('!z-10');
  }

  open() {
    if (this.stickyButton) {
      this.stickyButton.classList.add('!z-10');
    }

    this.panel.style.top = `${this.getBoundingClientRect().bottom - 2}px`;


    this.panel.classList.remove('hidden');

    setTimeout(() => {
      this.isOpen = true;
      this.panel.classList.remove('translate-x-[-100%]');
      this.panel.classList.add('translate-x-0');
      this.panel.setAttribute('aria-hidden', 'false');

      if (this.overlay) {
        this.overlay.classList.remove('hidden');
      }

      if (this.toggleButton) {
        this.toggleButton.classList.add('cb-hamburger--active');
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.toggleButton.setAttribute('aria-label', 'Close menu');
      }

      this.applyScrollLock();
    }, 300);

  }

  close() {
    if (this.stickyButton) {
      this.stickyButton.classList.remove('!z-10');
    }

    this.isOpen = false;
    this.panel.classList.remove('translate-x-0');
    this.panel.classList.add('translate-x-[-100%]');
    this.panel.setAttribute('aria-hidden', 'true');

    if (this.overlay) {
      this.overlay.classList.add('hidden');
    }

    if (this.toggleButton) {
      this.toggleButton.classList.remove('cb-hamburger--active');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.toggleButton.setAttribute('aria-label', 'Open menu');
    }

    this.applyScrollUnlock();

    this.closeAllSublevels();
  }

  switchTab(tabName) {
    this.activeTab = tabName;

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.drawerTab === tabName;
      tab.classList.toggle('cb-drawer-tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.contents.forEach((content) => {
      const isActive = content.dataset.drawerContent === tabName;
      content.classList.toggle('hidden', !isActive);
    });

    this.closeAllSublevels();
  }

  openSublevel(handle) {
    const activeContent = this.panel.querySelector(
      `[data-drawer-content="${this.activeTab}"]`
    );
    if (!activeContent) return;

    const sublevel = activeContent.querySelector(`[data-sublevel="${handle}"]`);
    if (!sublevel) return;

    sublevel.classList.remove('translate-x-full');
    sublevel.classList.add('translate-x-0');
    sublevel.setAttribute('aria-hidden', 'false');

    const mainLevel = activeContent.querySelector('[data-drawer-level="main"]');
    if (mainLevel) {
      mainLevel.classList.add('translate-x-[-100%]');
    }
  }

  closeSublevel(backButton) {
    const sublevel = backButton.closest('[data-drawer-level="sub"]');
    if (!sublevel) return;

    sublevel.classList.remove('translate-x-0');
    sublevel.classList.add('translate-x-full');
    sublevel.setAttribute('aria-hidden', 'true');

    const activeContent = sublevel.closest('[data-drawer-content]');
    const mainLevel = activeContent?.querySelector(
      '[data-drawer-level="main"]'
    );
    if (mainLevel) {
      mainLevel.classList.remove('translate-x-[-100%]');
    }
  }

  closeAllSublevels() {
    this.panel.querySelectorAll('[data-drawer-level="sub"]').forEach((sub) => {
      sub.classList.remove('translate-x-0');
      sub.classList.add('translate-x-full');
      sub.setAttribute('aria-hidden', 'true');
    });

    this.panel
      .querySelectorAll('[data-drawer-level="main"]')
      .forEach((main) => {
        main.classList.remove('translate-x-[-100%]');
      });
  }
}

if (!customElements.get('mobile-drawer')) {
  customElements.define('mobile-drawer', MobileDrawer);
}
